import { APIBaseService } from './base.api';
import {
  ScheduleGetAvailabilityQueryDto,
  ScheduleGetAvailabilityRequestDto,
  ScheduleGetAvailabilityResponseDto,
} from './types/schedule';

export class APIScheduleService extends APIBaseService {
  static async getAvailability(
    body: ScheduleGetAvailabilityRequestDto,
    query: ScheduleGetAvailabilityQueryDto,
  ): Promise<ScheduleGetAvailabilityResponseDto> {
    const searchParams = new URLSearchParams(query as any);
    const url = new URL(
      `${
        APIBaseService.apiUrl
      }/api/schedule/get-availability?${searchParams.toString()}`,
    ).href;
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    const resD = (await res.json()) as ScheduleGetAvailabilityResponseDto;
    return resD;
  }
}
